module.exports = __webpack_public_path__ + "img/Emblem_of_Uzbekistan.dfc1405c.svg";